import type { MouseEventHandler, ReactNode } from 'react';
import { ClipSpinner } from '~/components/ui/spinners/ClipSpinner';
import { cn } from '~/utils';

export type IButtonProps = {
  children: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  width?: string;
  variant?: 'primary' | 'secondary' | 'ghost' | 'accent' | 'ghost-primary';
  disabled?: boolean;
  loading?: boolean;
  outline?: boolean;
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export function Button(props: IButtonProps) {
  const { children, width, loading, className, onClick, type } = props;

  const disabled = props.disabled || loading;
  const variant = props.variant || 'primary';

  const variantClasses: Record<string, string> = {
    primary: 'bg-prim text-neut-0 hover:bg-prim-hover',
    secondary:
      'bg-neut-bg text-neut-prim hover:bg-neut-hover outline-2 outline-neut-border',
    ghost: 'bg-transparent text-neut-prim hover:bg-neut-hover',
    accent: 'bg-neut-bg outline-2 outline-prim text-prim hover:bg-neut-hover',
    'ghost-primary': 'bg-transparent text-prim hover:text-prim-hover',
  };

  return (
    <button
      type={type || 'button'}
      disabled={disabled || loading}
      style={{ width: width ? width : '100%' }}
      onClick={onClick}
      className={cn(
        'py-3 px-4 text-sm font-medium rounded-md transition-colors duration-200 focus:outline-none flex justify-center items-center gap-2',
        variantClasses[variant],
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className
      )}
    >
      {loading ? (
        <div className="flex gap-2 justify-center items-center ">
          {children} <ClipSpinner />
        </div>
      ) : (
        children
      )}
    </button>
  );
}
